var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "mt-7 mb-10 pb-10", attrs: { "grid-list-lg": "" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "mx-auto", attrs: { cols: "12", sm: "6" } },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("seasonTicket.title")))]),
                  _vm.loadingOrderId
                    ? _c(
                        "v-row",
                        {
                          staticClass: "py-5",
                          attrs: {
                            "align-content": "center",
                            justify: "center"
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.passHolders
                    ? _c(
                        "v-form",
                        {
                          ref: "registerForm",
                          attrs: { "lazy-validation": "" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.handleFormSubmit.apply(null, arguments)
                            }
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.register()
                            }
                          },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _vm._l(_vm.passHolders, function(i, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c("v-col", { attrs: { cols: "12" } }, [
                                      _c("h4", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("seasonTicket.person")
                                          ) +
                                            " " +
                                            _vm._s(index + 1)
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            readonly: _vm.isReadOnly,
                                            label: _vm.$t("seasonTicket.name"),
                                            filled: "",
                                            rules: [
                                              index !== 4
                                                ? _vm.rules.required
                                                : _vm.rules.allow
                                            ]
                                          },
                                          model: {
                                            value: i.firstName,
                                            callback: function($$v) {
                                              _vm.$set(i, "firstName", $$v)
                                            },
                                            expression: "i.firstName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            readonly: _vm.isReadOnly,
                                            label: _vm.$t(
                                              "seasonTicket.surname"
                                            ),
                                            filled: "",
                                            rules: [
                                              index !== 4
                                                ? _vm.rules.required
                                                : _vm.rules.allow
                                            ]
                                          },
                                          model: {
                                            value: i.lastName,
                                            callback: function($$v) {
                                              _vm.$set(i, "lastName", $$v)
                                            },
                                            expression: "i.lastName"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            readonly: _vm.isReadOnly,
                                            label: _vm.$t("seasonTicket.city"),
                                            filled: "",
                                            rules: [
                                              index !== 4
                                                ? _vm.rules.required
                                                : _vm.rules.allow
                                            ]
                                          },
                                          model: {
                                            value: i.city,
                                            callback: function($$v) {
                                              _vm.$set(i, "city", $$v)
                                            },
                                            expression: "i.city"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            readonly: _vm.isReadOnly,
                                            label: _vm.$t(
                                              "seasonTicket.birthday"
                                            ),
                                            filled: "",
                                            rules: [
                                              index !== 4
                                                ? _vm.rules.required
                                                : _vm.rules.allow,
                                              _vm.rules.birthYear
                                            ],
                                            type: "number"
                                          },
                                          model: {
                                            value: i.birthYear,
                                            callback: function($$v) {
                                              _vm.$set(i, "birthYear", $$v)
                                            },
                                            expression: "i.birthYear"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm.passHolders && !_vm.isReadOnly
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: "",
                                            depressed: "",
                                            tile: "",
                                            color: "primary",
                                            loading: _vm.loading,
                                            disabled: _vm.loading
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.register()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("seasonTicket.register")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }